/*
 * @Description: 订单管理
 * @Author: 杨志航
 * @Date: 2026-05-08 17:02:43
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import QuickRefund from './QuickRefund'
import TransferOrder from './TransferOrder'
import VendorBalance from './VendorBalance'
import InfoEdit from './InfoEdit'
import ProfitManage from './ProfitManage'
import QcddOrder from './QcddOrder'
import './assets/style.scss'

const Index = ({ match, history }) => {
  return (
    <div>
      <Switch>
        <Route path={match.path + '/quickRefund'} component={QuickRefund} />
        <Route path={match.path + '/transferOrder'} component={TransferOrder} />
        <Route path={match.path + '/vendorBalance'} component={VendorBalance} />
        <Route path={match.path + '/infoEdit'} component={InfoEdit} />
        <Route path={match.path + '/profitManage'} component={ProfitManage} />
        <Route path={match.path + '/qcddOrder'} component={QcddOrder} />
        <Route component={QuickRefund} />
      </Switch>
    </div>
  )
}

export default Index